export enum ADDRESS_FIELDS {
  AVENUE = 'avenue',
  BLOCK = 'block',
  BUILDING = 'building',
  STREET = 'street',
  CITY = 'city',
  AREA = 'area',
  HOUSE_NUMBER = 'unitNo',
}

export enum ADDRESS_TYPES {
  HOME = 'home',
  APARTMENT = 'apartment',
  OFFICE = 'office',
}
